import React, { useState } from "react";
import useLongPress from "../hooks/useLongPress";
import * as Const from "../_Const";
import useScreenType from "../hooks/useScreenType";
import Button from "./Button";
import { useFormCtx } from "./../FormContext";

const HiddenMenuBar = () => {
  const { runRestartOrShutdown, beep } = useFormCtx();
  const screenType = useScreenType();
  const [visible, setVisible] = useState(false);

  const onLongPress = async () => {
    setVisible(true);
    await beep();
    //console.log("longpress is triggered:");
  };
  const handleClick = () => {
    if (visible) {
      //console.log("click is triggered");
      //onClick();
    }
  };

  const close = (operation) => {
    if (visible) {
      setVisible(false);
    }
    if (operation) {
      runRestartOrShutdown(operation);
    }
  };

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "btn":
          css = "w-14";
          break;
        case "menu-btn":
          css = "w-full h-10 text-lg mt-2 rounded-none";
          break;
        case "close-btn":
          css = "h-10 text-lg mt-2 rounded-none";
          break;
        case "hidden-btn":
          css = "h-10 w-10";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "btn":
          css = "w-[7rem]";
          break;
        case "menu-btn":
          css = "w-full h-16 text-lg mt-4 rounded-none";
          break;
        case "close-btn":
          css = "h-16 text-lg mt-4 rounded-none";
          break;
        case "hidden-btn":
          css = "h-16 w-16";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "btn":
          css = "w-[7rem]";
          break;
        case "menu-btn":
          css = "w-full h-20 text-lg mt-4 rounded-none";
          break;
        case "close-btn":
          css = "h-20 text-lg mt-4 rounded-none";
          break;
        case "hidden-btn":
          css = "h-20 w-20";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "btn":
          css = "w-[7rem]";
          break;
        case "menu-btn":
          css = "w-full h-20 text-lg mt-4 rounded-none";
          break;
        case "close-btn":
          css = "h-20 text-lg mt-4 rounded-none";
          break;
        case "hidden-btn":
          css = "h-20 w-20";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 1500,
  };
  const longPressEvent = useLongPress(onLongPress, handleClick, defaultOptions);
  const isTerminal = Const.isTerminal();

  return (
    <>
      {visible && (
        <>
          <div className="absolute top-0 left-0 w-full h-full bg-accent-dark opacity-80 z-50"></div>
          <div className="absolute  p-4 bg-white w-1/2 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 drop-shadow-xl z-50">
            <div className="text-accent-dark text-3xl">Menu</div>
            <Button title="Restart" showIcon={false} type="clickonce" className={`${getCssFor("menu-btn")}`} onClick={() => close(Const.OPERATION_RESTART)} />
            <Button title="Vypnout" showIcon={false} type="clickonce" className={`${getCssFor("menu-btn")}`} onClick={() => close(Const.OPERATION_SHUTDOWN)} />
            <div className="flex place-content-end items-end mt-4">
              <Button title="Zavřít" showIcon={false} type="error" className={`${getCssFor("close-btn")} `} onClick={() => close(null)} />
            </div>
          </div>
        </>
      )}

      <div className="absolute right-0 bottom-0 bg-accenta">
        <button {...longPressEvent} className={`${getCssFor("btn")}  flex place-content-center items-center bg-transparent `}>
          {isTerminal && <span className={`${getCssFor("hidden-btn")}`} />}
        </button>
      </div>
    </>
  );
};

export default HiddenMenuBar;
